/**
 * FIX: Correção para tela branca ao adicionar no carrinho
 * Este arquivo corrige problemas comuns de adicionar ao carrinho
 */

(function() {
  'use strict';
  
  console.log('🔧 Fix Cart Bug carregado');
  
  // Previne múltiplos cliques no botão de adicionar ao carrinho
  var isAddingToCart = false;
  
  // Intercepta o evento de adicionar ao carrinho
  document.addEventListener('click', function(e) {
    var target = e.target.closest('[data-action="add-to-cart"]');
    
    if (!target) return;
    
    // Se já está processando, cancela
    if (isAddingToCart) {
      console.log('⚠️ Já está adicionando ao carrinho, aguarde...');
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    console.log('✅ Iniciando adição ao carrinho');
    isAddingToCart = true;
    
    // Libera após 3 segundos (timeout de segurança)
    setTimeout(function() {
      isAddingToCart = false;
      console.log('🔓 Liberado para nova adição');
    }, 3000);
    
  }, true); // Usa capture para pegar antes de outros listeners
  
  // Monitora erros de adicionar ao carrinho
  document.addEventListener('product:added', function(e) {
    console.log('✅ Produto adicionado com sucesso:', e.detail);
    isAddingToCart = false;
  });
  
  // Monitora quando o loading termina
  document.addEventListener('theme:loading:end', function() {
    console.log('⏹️ Loading finalizado');
    // Garante que o flag seja resetado
    setTimeout(function() {
      isAddingToCart = false;
    }, 500);
  });
  
  // Previne erro de serialização de formulário
  window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('cart')) {
      console.error('❌ Erro detectado no carrinho:', e.message);
      isAddingToCart = false;
      
      // Remove loading se estiver travado
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  });
  
  // Fix para formulários sem action correto
  function fixCartForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    
    forms.forEach(function(form) {
      // Verifica se o formulário tem os campos necessários
      if (!form.querySelector('[name="id"]')) {
        console.warn('⚠️ Formulário sem campo ID:', form);
      }
      
      if (!form.querySelector('[name="quantity"]')) {
        console.warn('⚠️ Formulário sem campo quantity:', form);
        // Adiciona campo quantity se não existir
        var qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(qtyInput);
      }
    });
  }
  
  // Executa fix quando DOM carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCartForms);
  } else {
    fixCartForms();
  }
  
  // Re-executa fix quando conteúdo dinâmico é carregado
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        fixCartForms();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('✅ Fix Cart Bug inicializado');
  
})();
